module.exports = __webpack_public_path__ + "img/lg_ring_g_s_1_null@2x.e6c29651.png";